import React from 'react';
import { ControlRenderer, FetchAvailable } from '../globals/ProjectVars';

export class VINDex extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            reqFailed: false
        };
    }

    componentDidMount() {
        if (!this.props.dataCache) {
            let reqUrl = `${ControlRenderer}PromoVINDexLinks`;

            if (FetchAvailable) {
                fetch(reqUrl)
                    .then((res) => {
                        if (res.ok) {
                            return res.json();
                        }
                        else {
                            this.setState({ reqFailed: true });
                            this.props.ajaxFailed();
                        }
                    })
                    .then((resJson) => {
                        this.setState({
                            data: resJson
                        });
                    });
            }
            else {
                $j.get(reqUrl, (res) => {
                    this.setState({
                        data: res
                    });
                }, "json")
                    .fail(() => {
                        this.setState({ reqFailed: true });
                        this.props.ajaxFailed();
                    });
            }
        }
    }

    render() {
        if (this.props.dataCache) {
            return (
                <LoadedVDXLinks links={this.props.dataCache} onComponentMount={this.props.vdxLinksLoaded} />
            );
        }
        else {
            if (!this.state.reqFailed) {
                return (
                    (this.state.data !== null && this.state.data.length > 0) ? <LoadedVDXLinks links={this.state.data} onComponentMount={this.props.vdxLinksLoaded} /> : <LinksLoading />
                );
            }
            else {
                return (
                    <DefaultVDXLinks onComponentMount={this.props.vdxLinksLoaded} />
                );
            }
        }
    }
}

const LinksLoading = () => {
    return (
        <li className="loading">Loading</li>
    );
}

class DefaultVDXLinks extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.onComponentMount(null);
    }

    render() {
        return (
            <li>
                <p className="alert"><span className="glyphicon glyphicon-warning-sign" aria-hidden="true"></span>Sorry, something went wrong.</p>
                <p>But you can still view these links if you login and type <kbd>Ctrl + e</kbd> on your keyboard or click on the VINdex link in the upper right.</p>
                <LoginButton />
            </li>
        );
    }
}

class LoadedVDXLinks extends React.Component {

    constructor(props) {
        super(props);
        this.mappedLinks = props.links.map((link, index) => {
            if (link.linkText === link.fullText) {
                return (
                    <li key={index}>
                        <a href={link.href} target="_blank">{link.linkText}</a>
                    </li>
                );
            } else {
                let extraText = link.fullText.replace(link.linkText, '');
                return (
                    <li key={index}>
                        <a href={link.href} target="_blank">{link.linkText}</a>{extraText}
                    </li>
                );
            }
        });
    }

    componentDidMount() {
        this.props.onComponentMount(this.props.links);
    }

    render() {
        return (
            <React.Fragment>{this.mappedLinks}</React.Fragment>
        );
    }
}